import * as Dialog from '@radix-ui/react-dialog'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import Alert from './Alert/Alert'
import Button from './Button/Button'
import styles from './ConfirmModal.module.scss'
import Divider from './Divider/Divider'

type ConfirmModalProps = {
  header: string
  subheader?: React.ReactNode
  open: boolean
  confirmButton?: React.ReactNode
  description?: React.ReactNode
  loading?: boolean
  alertText?: React.ReactNode
  onOpenChange?: (isOpen: boolean) => void
  onConfirm?: () => void
  onCancel?: () => void
  dataTestId?: string
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const { t } = useTranslation(['common'])
  return (
    <Dialog.Root open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          aria-modal="true"
          className={clsx(styles.content)}
          data-test-id={props.dataTestId}
          {...(props.description ? {} : { 'aria-describedby': undefined })}
        >
          <Dialog.Title className={styles.title}>{props.header}</Dialog.Title>

          {props.description ? (
            <Dialog.Description className={styles.description}>
              {props.description}
            </Dialog.Description>
          ) : null}

          <Divider className={styles.divider} />

          <div className={styles.subheader} data-test-id="modal-text">
            {props.subheader}

            {props.alertText ? (
              <Alert message={props.alertText} variant="warning" />
            ) : null}
          </div>

          <div className={styles.footer}>
            <Dialog.Close asChild>
              <Button
                className={styles.closeButton}
                variant="tertiary"
                onClick={props.onCancel}
              >
                {t('button.cancel')}
              </Button>
            </Dialog.Close>

            {props.confirmButton ? (
              props.confirmButton
            ) : (
              <Button
                className={styles.submitButton}
                onClick={props.onConfirm}
                loading={props.loading}
              >
                {t('button.confirm')}
              </Button>
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ConfirmModal
